module.exports = __webpack_public_path__ + "img/iq.059bad53.png";